module.exports = __webpack_public_path__ + "media/images/img-peter-cauton-4a3a2226070fe64b446729c9966bc7f1.jpg";